<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title" :title1="title1" :loading="loading" />
        <!-- /product list -->
        <div class="card">
          <div class="card-body">
            <div class="table-top">
              <!-- <div class="card" id="filter_inputs"> -->
                <div class="card-body pb-0">
                  <div class="row">
                    <div class="col-lg-2 col-sm-6 col-12">
                      <div class="form-group">
                        <div class="input-groupicon">
                          <datepicker
                            v-model="startDate"
                            placeholder="Start Date"
                            class="picker"
                            :editable="true"
                            :clearable="false"
                            @click="timeframechange()"
                          />
                        <div class="addonset">
                          <img src="../../../assets/img/icons/calendars.svg" alt="img" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-sm-6 col-12">
                    <div class="form-group">
                      <div class="input-groupicon">
                        <datepicker
                          v-model="endDate"
                          placeholder="End Date"
                          class="picker"
                          :editable="true"
                          :clearable="false"
                          @click="timeframechange()"
                        />
                        <div class="addonset">
                          <img src="../../../assets/img/icons/calendars.svg" alt="img" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-12">
                    <div class="form-group">
                      <a v-on:click="generateReport()" class="btn btn-submit me-2">Generate Report</a>
                    </div>
                  </div>
                </div>
              </div>
            <!-- </div> -->
              <!-- <div class="search-set">
                <div class="search-path">
                  <a
                    class="btn btn-filter"
                    id="filter_search"
                    v-on:click="filter = !filter"
                    :class="{ setclose: filter }"
                  >
                    <img src="../../../assets/img/icons/filter.svg" alt="img" />
                    <span
                      ><img src="../../../assets/img/icons/closes.svg" alt="img"
                    /></span>
                  </a>
                </div>
                <div class="search-input">
                  <a class="btn btn-searchset"
                    ><img src="../../../assets/img/icons/search-white.svg" alt="img"
                  /></a>
                  <div id="DataTables_Table_0_filter" class="dataTables_filter">
                    <label>
                      <input
                        type="search"
                        class="form-control form-control-sm"
                        placeholder="Search..."
                        aria-controls="DataTables_Table_0"
                      />
                    </label>
                  </div>
                </div>
              </div> -->
              <div class="wordset">
                <ul>
                  <!-- <li>
                    <a data-bs-toggle="tooltip" data-bs-placement="top" title="pdf"
                      ><img src="../../../assets/img/icons/pdf.svg" alt="img"
                    /></a>
                  </li> -->
                  <li>
                     <a data-bs-toggle="tooltip" data-bs-placement="top" title="excel" @click="exportToCSV">
                       <img src="../../../assets/img/icons/excel.svg" alt="img" />
                     </a>
                  </li>
                  <!-- <li>
                    <a data-bs-toggle="tooltip" data-bs-placement="top" title="print"
                      ><img src="../../../assets/img/icons/printer.svg" alt="img"
                    /></a>
                  </li> -->
                </ul>
              </div>
            </div>
            <!-- /Filter -->
            <!-- <div
              class="card"
              id="filter_inputs"
              :style="{
                display: filter ? 'block' : 'none',
              }"
            >
              <div class="card-body pb-0">
                <div class="row">
                  <div class="col-lg-2 col-sm-6 col-12">
                    <div class="form-group">
                      <div class="input-groupicon">
                        <datepicker
                          v-model="startdate"
                          placeholder="Choose Date"
                          class="picker"
                          :editable="true"
                          :clearable="false"
                        />
                        <div class="addonset">
                          <img src="../../../assets/img/icons/calendars.svg" alt="img" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-sm-6 col-12">
                    <div class="form-group">
                      <div class="input-groupicon">
                        <datepicker
                          v-model="startdate"
                          placeholder="Choose Date"
                          class="picker"
                          :editable="true"
                          :clearable="false"
                        />
                        <div class="addonset">
                          <img src="../../../assets/img/icons/calendars.svg" alt="img" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-1 col-sm-6 col-12 ms-auto">
                    <div class="form-group">
                      <a class="btn btn-filters ms-auto"
                        ><img src="../../../assets/img/icons/search-whites.svg" alt="img"
                      /></a>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
            <!-- /Filter -->
            <div class="table-responsive">
              <a-table
                :columns="columns"
                :data-source="data"
              >
                <template #bodyCell="{ column, record }">
                  <template v-if="column.key === 'itemid'">
                    <div class="productimgname">
                      <a class="product-img">
                        <img
                          :src="require(`../../../assets/img/product/${record.img}`)"
                          alt="product"
                        />
                      </a>
                      <a href="javascript:void(0);">{{ record.categoryname }}</a>
                    </div></template
                  >
                </template>
              </a-table>
            </div>
          </div>
        </div>
        <!-- /product list -->
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
const columns = [
  {
    sorter: true,
  },

  {
    title: "Category Name",
    dataIndex: "categoryname",
    sorter: {
      compare: (a, b) => {
        a = a.categoryname.toLowerCase();
        b = b.categoryname.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Item Name",
    dataIndex: "itemname",
    sorter: {
      compare: (a, b) => {
        a = a.itemname.toLowerCase();
        b = b.itemname.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Record Date",
    dataIndex: "recorddate",
    sorter: {
      compare: (a, b) => {
        a = a.recorddate.toLowerCase();
        b = b.recorddate.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Record Type",
    dataIndex: "recordtype",
    sorter: {
      compare: (a, b) => {
        a = a.recordtype.toLowerCase();
        b = b.recordtype.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
   {
    title: "Invoice Date",
    dataIndex: "invoicedate",
    sorter: {
      compare: (a, b) => {
        a = a.quantity;
        b = b.quantity;
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Branch",
    dataIndex: "branch",
    sorter: {
      compare: (a, b) => {
        a = (a.branch || '').toLowerCase();
        b = (b.branch || '').toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Quantity",
    dataIndex: "quantity",
    sorter: {
      compare: (a, b) => {
        a = a.quantity;
        b = b.quantity;
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Amount",
    dataIndex: "amount",
    sorter: (a, b) => a.amount - b.amount,
    customRender: ({ text }) => `₹${parseFloat(text).toFixed(2)}`,
  },
  {
    title: "Opening Balance",
    dataIndex: "opening_balance",
    sorter: {
      compare: (a, b) => {
        a = a.opening_balance;
        b = b.opening_balance;
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Closing Balance",
    dataIndex: "closing_balance",
    sorter: {
      compare: (a, b) => {
        a = a.closing_balance;
        b = b.closing_balance;
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
];
export default {  
  data() {
    return {
      filter: false,
      timeframechanged: false,
      loading: true,
      title: "Weekly Report",
      title1: "View Weekly Report",
      startDate: null,
      endDate: null,
      data: null,
      timeframechanged: false,
      columns,
      columnTitleMap: {
        categoryname: "Category Name",
        itemname: "Item Name",
        recorddate: "Record Date",
        recordtype: "Record Type",
        branch: "Branch",
        quantity: "Quantity",
        amount: "Amount",
        opening_balance:"Opening Balance",
        closing_balance:"Closing  Balance",
      },
    };
  },
  methods:{
    timeframechange() { console.log("time f changed");
      this.timeframechanged = true;
    },
    async generateReport() {
      this.loading = true;
      const startDateParam = this.formatDate(this.startDate);
      const endDateParam = this.formatDate(this.endDate);
      const apiUrl = `/v1/weeklyreport?startdate=${startDateParam}&enddate=${endDateParam}`;
      
      await axios.get(apiUrl)
        .then(response => {
          this.data = response.data;
          this.timeframechanged = false;
          this.loading = false;
        })
        .catch(error => {
          console.error(error);
          this.errored = true;
          this.loading = false;
        });
    },
    formatDate(date) {
      const formattedDate = new Date(date);
      const year = formattedDate.getFullYear();
      const month = String(formattedDate.getMonth() + 1).padStart(2, '0');
      const day = String(formattedDate.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    async exportToCSV() {
      // Check if data is available
      if (!this.data || this.data.length === 0) {
        console.warn("No data to export.");
        Swal.fire("No data to export", "Generate a report to export to CSV");
        return;
      }
      if (this.timeframechanged) {
        await this.generateReport().then(res => this.generateCSV());
      } else {
        this.generateCSV();
      }
    },
    generateCSV() {
      // Map API keys to custom titles
      const mappedData = this.data.map(item => {
        const mappedItem = {};
        for (const key in item) {
          if (key in this.columnTitleMap) {
            mappedItem[this.columnTitleMap[key]] = item[key];
          }
        }
        return mappedItem;
      });

      // Extract column headers and values
      const headers = Object.keys(mappedData[0]);
      const values = mappedData.map(item => headers.map(header => item[header]));

      // Create CSV content
      const csvContent =
        [headers.join(','), ...values.map(row => row.join(','))].join('\n');

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

      // Generate the filename with start date and end date
      const startDateString = this.formatDate(this.startDate);
      const endDateString = this.formatDate(this.endDate);
      const filename = `weekly_report_${startDateString}_${endDateString}.csv`;

      // Create a download link
      const link = document.createElement('a');

      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, filename);
      } else {
        const url = URL.createObjectURL(blob);
        // Set link properties
        link.href = url;
        link.setAttribute('download', filename);

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(url);
      }
    },
  },
  beforeMount() {
    const currentDate = new Date();
    const week = new Date();
    week.setDate(currentDate.getDate() - 6);

    this.startDate = week;
    this.endDate = currentDate;

    this.generateReport();
  },
  name: "salesreport",
};
</script>
